import { useAppSelector } from 'app/hooks/redux';
import { MenuItem } from './MenuItem';

export const MenuInner = () => {
  const currentUser = useAppSelector(state => state.user.currentUser);
  const showSupport = process.env.REACT_APP_SHOW_SUPPORT_ROUTE_AND_LINK === 'true';

  if (currentUser) {
    return (
      <>
        <MenuItem title="Logins" to="/cards/logins" />
        <MenuItem title="Cards" to="/cards" />
        {/* <MenuItem title="Firmwares" to="/firmwares" /> */}
        {/* <MenuItem title="Tools" to="/tools" /> */}
        <MenuItem title="Files" to="/files" />
        <MenuItem title="Downloads" to="/downloads" />
        {showSupport && <MenuItem title="Support" to="/support/ticket" activePath="/support" />}
      </>
    );
  }

  return (
    <>
      <MenuItem title="Home" to="/" />
    </>
  );
};
